module.exports = "<iframe style=\"border: 0\" [src]=\"url\" width=\"100%\" height=\"100%\"></iframe>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/external-billing/external-payments/external-payments.component.html
// module id = 2445
// module chunks = 66